export default {
    p: {
        fo: {
            summary: {
                title: '功能概览',
                utcNote: 'UTC 业务日口径',
                window: '窗口（UTC）：{start} ~ {end}',
                windowEnd: '截至（UTC）：{end}',
                registeredUsers: '注册用户',
                watchUsers: '观看用户',
                column: {
                    feature: '功能',
                    caliber: '参与口径',
                    participants: '参与人数',
                    denominator: '分母',
                    rate: '参与率',
                    drilldown: '下钻',
                },
                drilldownAction: '查看明细',
                rateNull: '—',
                registerPvNote: '暂无注册入口 PV 上报',
            },
            denominatorMetric: {
                register_pv: '注册入口访问量',
                registered_users: '注册用户',
                watch_users: '观看用户',
            },
            feature: {
                register: '注册',
                watch: '观看',
                report: '举报',
                not_interested: '不感兴趣',
                publish: '发布内容',
                launch: '发射代币',
                buy: '买入代币',
                sell: '卖出代币',
            },
            caliber: {
                register: '历史累计新注册账号',
                watch: '历史累计观看过剧集或视频',
                report: '历史累计提交举报（不含不感兴趣）',
                not_interested: '历史累计标记不感兴趣',
                publish: '历史累计发布过内容',
                launch: '历史累计发射过代币',
                buy: '历史累计买入成交（CONFIRMED）',
                sell: '历史累计卖出成交（CONFIRMED）',
            },
            detail: {
                title: '参与明细',
                empty: '点击上方功能行查看参与用户明细',
                export: '导出 CSV',
                refresh: '刷新',
                column: {
                    userId: '用户 ID',
                    wallet: '钱包地址',
                    times: '参与次数',
                    firstAt: '首次参与时间',
                    lastAt: '最后参与时间',
                },
                exportSuccess: '导出任务已创建',
            },
        },
    },
};
